import storage from 'store'

import { SET_LANGUAGE, TOGGLE_SIDE_MENU_COLLAPSED } from '../mutation-types'
import i18n from '@/locales'

const state = {
  // languag 这个键名是为了兼容第一版的应用
  lang: 'zh-CN',
  isSideMenuCollapsed: false
}

const mutations = {
  [SET_LANGUAGE] (state, lang, antd = {}) {
    state.lang = lang
    state._antLocale = antd
    storage.set('languag', lang === 'en-US' ? 'en' : 'zh')
  },
  [TOGGLE_SIDE_MENU_COLLAPSED] (state) {
    state.isSideMenuCollapsed = !state.isSideMenuCollapsed
  }
}

const actions = {
  setLang ({ commit }, lang) {
    commit(SET_LANGUAGE, lang)
    i18n.global.locale.value = lang
  }
}

export default {
  state,
  mutations,
  actions
}
